/**
 * 侧边栏样式常量
 * 集中管理样式，便于维护和主题定制
 * 支持亮色/暗色主题
 */

// 侧边栏宽度
export const SIDEBAR_WIDTH = 240;
export const SIDEBAR_COLLAPSED_WIDTH = 80;

/**
 * 获取主题相关的样式
 * @param {boolean} isDark - 是否为暗色主题
 */
export const getThemedStyles = (isDark = false) => {
  const colors = isDark ? {
    bg: '#141414',
    bgHover: '#1f1f1f',
    border: '#303030',
    text: 'rgba(255, 255, 255, 0.88)',
    textSecondary: 'rgba(255, 255, 255, 0.65)',
    textTertiary: 'rgba(255, 255, 255, 0.45)',
    primary: '#E8A847',
    shadow: '2px 0 8px rgba(0, 0, 0, 0.3)',
  } : {
    bg: '#ffffff',
    bgHover: '#fafafa',
    border: '#f0f0f0',
    text: 'rgba(0, 0, 0, 0.88)',
    textSecondary: 'rgba(0, 0, 0, 0.65)',
    textTertiary: 'rgba(0, 0, 0, 0.45)',
    primary: '#F5A523',
    shadow: '2px 0 8px rgba(0, 0, 0, 0.05)',
  };

  return {
    siderStyle: {
      position: 'fixed',
      left: 0,
      top: 0,
      bottom: 0,
      zIndex: 100,
      background: colors.bg,
      boxShadow: colors.shadow,
      display: 'flex',
      flexDirection: 'column',
      transition: 'background-color var(--transition-normal, 250ms), box-shadow var(--transition-normal, 250ms)',
    },
    headerStyle: {
      height: 64,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 16px',
      borderBottom: `1px solid ${colors.border}`,
      flexShrink: 0,
      transition: 'border-color var(--transition-normal, 250ms)',
    },
    logoStyle: {
      fontSize: 18,
      fontWeight: 600,
      color: colors.primary,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    searchContainerStyle: {
      padding: '12px 16px',
      borderBottom: `1px solid ${colors.border}`,
      flexShrink: 0,
      transition: 'border-color var(--transition-normal, 250ms)',
    },
    footerStyle: {
      padding: '12px 16px',
      borderTop: `1px solid ${colors.border}`,
      flexShrink: 0,
      transition: 'border-color var(--transition-normal, 250ms)',
    },
    groupTitleStyle: {
      padding: '12px 16px 4px',
      fontSize: 12,
      color: colors.textTertiary,
      fontWeight: 500,
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      transition: 'color var(--transition-normal, 250ms)',
    },
    collapseButtonStyle: {
      cursor: 'pointer',
      fontSize: 16,
      color: colors.textTertiary,
      transition: 'color var(--transition-fast, 150ms)',
    },
    emptyContainerStyle: {
      padding: '40px 16px',
      textAlign: 'center',
    },
    colors,
  };
};

// 默认样式（亮色主题）- 保持向后兼容
const defaultStyles = getThemedStyles(false);

// 侧边栏主容器样式
export const siderStyle = defaultStyles.siderStyle;

// 头部区域样式
export const headerStyle = defaultStyles.headerStyle;

// Logo 样式
export const logoStyle = defaultStyles.logoStyle;

// 菜单容器样式
export const menuContainerStyle = {
  flex: 1,
  overflow: 'auto',
  overflowX: 'hidden',
};

// 搜索框容器样式
export const searchContainerStyle = defaultStyles.searchContainerStyle;

// 底部区域样式
export const footerStyle = defaultStyles.footerStyle;

// 分组标题样式
export const groupTitleStyle = defaultStyles.groupTitleStyle;

// 折叠按钮样式
export const collapseButtonStyle = defaultStyles.collapseButtonStyle;

// 空状态容器样式
export const emptyContainerStyle = defaultStyles.emptyContainerStyle;

// 导出所有样式常量
export const sidebarStyles = {
  SIDEBAR_WIDTH,
  SIDEBAR_COLLAPSED_WIDTH,
  siderStyle,
  headerStyle,
  logoStyle,
  menuContainerStyle,
  searchContainerStyle,
  footerStyle,
  groupTitleStyle,
  collapseButtonStyle,
  emptyContainerStyle,
  getThemedStyles,
};

export default sidebarStyles;
